export * from './src/component-with-sizes.component';
